// extracted by mini-css-extract-plugin
module.exports = {"TooltipContainer":"styles_TooltipContainer__13NjU","tooltip":"styles_tooltip__3VHwj"};